import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="number-input-lock"
// Stops number inputs from changing value via mouse wheel or ArrowUp/ArrowDown.
// Also covers the consumption modals, which load into the 'remote_modal' frame outside this element.
export default class extends Controller {
  connect() {
    this.onWheel = this.onWheel.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    document.addEventListener('wheel', this.onWheel, { capture: true, passive: true });
    document.addEventListener('keydown', this.onKeydown, true);
  }

  disconnect() {
    document.removeEventListener('wheel', this.onWheel, { capture: true });
    document.removeEventListener('keydown', this.onKeydown, true);
  }

  onWheel(event) {
    const input = this.lockedInput(event.target);

    // Blurring lets the page scroll instead of the focused input stepping its value.
    if (input && input === document.activeElement) input.blur();
  }

  onKeydown(event) {
    if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return;

    if (this.lockedInput(event.target)) event.preventDefault();
  }

  lockedInput(target) {
    if (!(target instanceof HTMLInputElement) || target.type !== 'number') return null;

    const inScope = this.element.contains(target) || target.closest('turbo-frame#remote_modal');
    return inScope ? target : null;
  }
}
